import { sign } from "crypto";

//营销活动管理
const create = resolve => require(['@/components/newMarking/marketCenter/index.vue'], resolve);
const manage = resolve => require(['@/components/newMarking/markManage/index.vue'], resolve);
const activity_created = resolve => require(['@/components/newMarking/markManage/activityCreated.vue'], resolve);
const activityChooseGoods = resolve => require(['@/components/newMarking/markManage/activityChooseGoods.vue'], resolve);
const marketing_details = resolve => require(['@/components/newMarking/markManage/marketing_details.vue'], resolve);
const createFinish = resolve => require(['@/components/newMarking/markManage/createdFinish.vue'], resolve);
// 拼团
const registercampaign = resolve =>
    require(["@/components/newMarking/markApply/index.vue"], resolve);
const groupApplyInfo = resolve =>
    require(["@/components/newMarking/markApply/registercampaign/groupApplyInfo.vue"], resolve); //拼团报名详情
const groupApply = resolve =>
    require(["@/components/newMarking/markApply/registercampaign/groupApply.vue"], resolve); //拼团报名
const supplementAmount = resolve =>
    require(["@/components/newMarking/markApply/registercampaign/supplementAmount.vue"], resolve); //活动库存补充提报
const recordInfo = resolve =>
    require(["@/components/newMarking/markApply/registercampaign/recordInfo.vue"], resolve); //拼团记录详情
const checkDetail = resolve =>
    require(["@/components/newMarking/markApply/registercampaign/checkDetail.vue"], resolve);
const choosesku = resolve =>
    require(["@/components/newMarking/markApply/registercampaign/choosesku.vue"], resolve);
const deploysku = resolve =>
    require(["@/components/newMarking/markApply/registercampaign/deploysku.vue"], resolve);
const rechoose = resolve =>
    require(["@/components/newMarking/markApply/registercampaign/rechoose.vue"], resolve);
// 平团
// 营销活动 报名
// const limitDiscount_details = resolve => require(["@/components/newMarking/markApply/mixedApply/limitDiscount/limitDiscount_details.vue"], resolve);
const activityDetails = resolve => require(["@/components/newMarking/markApply/mixedApply/activityDetails.vue"], resolve);
const thematicTopic_details = resolve => require(["@/components/newMarking/markApply/mixedApply/thematicTopic/thematicTopic_details.vue"], resolve);
//秒杀自购省 
const skillAndShareDetails = resolve => require(["@/components/newMarking/markApply/marketingCommon/skillAndShareDetails.vue"], resolve);
const skillAndShare_signUp = resolve => require(["@/components/newMarking/markApply/skillAndShares/signUp.vue"], resolve);
const skillAndShare_supplyment = resolve => require(["@/components/newMarking/markApply/skillAndShares/supplyment.vue"], resolve);
const skillAndShare_stock = resolve => require(["@/components/newMarking/markApply/skillAndShares/stock.vue"], resolve);

export default [{ //营销管理
        path: '/homeMain/newMarket/marketCenter',
        component: create,
    },
    { //营销管理
        path: '/homeMain/newMarket/manage',
        component: manage,
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/homeMain/newMarket/manage/marketing_details',
        component: marketing_details,
    },
    //选择商品页面
    {
        path: '/homeMain/newMarket/manage/activity_chooseGoods',
        component: activityChooseGoods,
    },
    
    //创建页面
    {
        path: '/homeMain/newMarket/manage/activity_created',
        component: activity_created,
    },
    // 创建完成
    {
        path:'/homeMain/newMarket/manage/created_finish',
        component:createFinish
    },
    /***平团 */
    {
        path: "/homeMain/marketing/groupApplyInfo",
        component: groupApplyInfo
    },
    {
        path: "/homeMain/marketing/groupApply",
        component: groupApply
    },
    {
        path: "/homeMain/marketing/supplementAmount",
        component: supplementAmount
    },
    {
        path: "/homeMain/marketing/recordInfo",
        component: recordInfo
    },

    {
        path: "/homeMain/marketing/deploysku",
        component: deploysku
    },
    {
        path: "/homeMain/marketing/registercampaign",
        component: registercampaign,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/homeMain/marketing/checkDetail",
        component: checkDetail
    },
    {
        path: "/homeMain/marketing/choosesku",
        component: choosesku
    },
    {
        path: "/homeMain/marketing/rechoose",
        component: rechoose
    },
    //拼团结束
    //营销活动报名
    // {
    //     path: "/homeMain/marketing/registercampaign/limitDiscount_details",
    //     component: limitDiscount_details,
    // },
    {
        path: "/homeMain/marketing/registercampaign/activityDetails",
        component: activityDetails,
    },
    {
        path: "/homeMain/marketing/registercampaign/thematicTopic_details",
        component: thematicTopic_details,
    },
    //秒杀自购省
    {
        path: "/homeMain/marketing/registercampaign/skillAndShareDetails",
        component: skillAndShareDetails,
    },
    {
        path: "/homeMain/marketing/registercampaign/skillAndShare_signUp",
        component: skillAndShare_signUp,
    },
    {
        path: "/homeMain/marketing/registercampaign/skillAndShare_supplyment",
        component: skillAndShare_supplyment,
    },
    {
        path: "/homeMain/marketing/registercampaign/skillAndShare_stock",
        component: skillAndShare_stock,
    },
];


// WEBPACK FOOTER //
// ./src/router/newMarket.js